module.exports = __webpack_public_path__ + "img/bg17.34ebdf6c.jpg";